import { SpeakerWithDetails } from '@goldcast/player-config/src/types/speaker-types';
import { getSpeakerNameAndTitle } from '@goldcast/player-config/src/utils/speakerUtils';
import { AlignedRecordings } from '@goldcast/player-config/src/types/clip-types';
import { isEntityScreenshare } from '@goldcast/player-config/src/utils/activityUtils';

export const getSpeakerName = (
  recording: AlignedRecordings,
  speakerDetails: Record<string, SpeakerWithDetails>
): string => {
  if (isEntityScreenshare(recording.entity)) {
    return recording.user.first_name + ' ' + recording.user.last_name + "'s Screenshare";
  }
  // TODO: @@HiteshChoudhary0098 this needs to be revisited. What backend stopped sending types for transcript mapping.
  // @ts-ignore
  const speakerId = recording.transcript_mapping?.speaker_labels[0];
  if (!speakerId || !speakerDetails[speakerId]) {
    return '';
  }

  const { name } = getSpeakerNameAndTitle(speakerDetails[speakerId]);

  return name;
};
